import { createDraftSafeSelector } from "@reduxjs/toolkit"
import { RootState } from "../store"
import { QuickTradeWidgetStateType } from "../reducer/quickTrades.reducer"

const state = (state: RootState) => state.quickTradeWidgetStore as QuickTradeWidgetStateType

export const selectQuickTrades = createDraftSafeSelector(state, (store) => store.quickTrades)
export const selectQuickTrade = (id: string) => createDraftSafeSelector(state, (store) => (store.quickTrades).find(s=>s.id===id))
export const selectQuickTradeDialogOpen = createDraftSafeSelector(state, (store) => store.settingsDialogOpen)
export const selectQuickTradeDialogMode = createDraftSafeSelector(state, (store) => store.dialogMode)
export const selectQuickTradeEditTemplateId = createDraftSafeSelector(state, (store) => store.editTemplateId)